import { render, staticRenderFns } from "./Questionaire.vue?vue&type=template&id=87372124&scoped=true"
import script from "./Questionaire.vue?vue&type=script&lang=js"
export * from "./Questionaire.vue?vue&type=script&lang=js"
import style0 from "./Questionaire.vue?vue&type=style&index=0&id=87372124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87372124",
  null
  
)

export default component.exports